import { render, staticRenderFns } from "./ProfChangePassword.vue?vue&type=template&id=15f621d8&"
import script from "./ProfChangePassword.vue?vue&type=script&lang=js&"
export * from "./ProfChangePassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports